import { Outlet } from "react-router-dom";

import { RestrictedAccess } from "../../../components/custom/RestrictedAccess";
import { Skeleton } from "../../../components/ui/skeleton";
import { ROLES } from "../../../constants/roles";
import { useOrganizationSelf } from "../../../hooks/useOrganizationSelf";

/**
 * Gate for every deployment tier view, and the content container the settings layout
 * renders its nested routes into.
 *
 * The API authorizes this independently — canAccessIntegrationScope rejects a
 * non-superadmin — so this only keeps the UI honest rather than being the control.
 */
export const DeploymentIntegrationsLayout = () => {
  const { data: orgSelf, isLoading } = useOrganizationSelf();

  // Only here so RestrictedAccess cannot flash before the role resolves.
  if (isLoading) {
    return (
      <div className="mx-auto w-full max-w-5xl px-8 py-10">
        <Skeleton className="mb-2 h-7 w-64" />
        <Skeleton className="h-4 w-96" />
      </div>
    );
  }

  if (orgSelf?.role !== ROLES.SUPERADMIN) {
    return (
      <RestrictedAccess
        className="h-full"
        description="Deployment integrations are managed by Needl super admins. Please contact your Needl representative if you need a source connected across workspaces."
      />
    );
  }

  return (
    <div className="flex min-h-0 flex-1 flex-col">
      <Outlet />
    </div>
  );
};
